var _style, _path, _path2, _path3, _text, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWaterLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 133 23.1",
    style: {
      enableBackground: "new 0 0 133 23.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_2_);}\r\n\t.st2{fill:url(#SVGID_3_);}\r\n\t.st3{fill:#171044;}\r\n\t.st4{font-family:'FranklinGothic-Demi';}\r\n\t.st5{font-size:20.28px;}\r\n\t.st6{fill:#121631;}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 77.88,
    y1: 85.4394,
    x2: -14,
    y2: 145.5094,
    gradientTransform: "matrix(1 0 0 1 -5.2 -113.65)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#71CDDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#4AC7E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    style: {
      stopColor: "#49C1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#4298CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#3B77B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#375BA3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#334998"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#2F3E90"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2E3B8E"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.8,14.6c-2.5,1.7-6.2-2.2-8.8-4.8c-3.5-3.6-6.7-4.3-7.9-4.5C7,5.3,6.9,5.3,6.9,5.2c0,0,0,0,0,0 c0,0,0,0,0-0.1C9,1.2,13.8-0.3,17.7,1.8c2.1,1.1,3.6,3.1,4.1,5.4c0,0.1,0,0.1,0.1,0.1c1.4,0.5,2.4,1.7,2.8,3.1l0,0 C24.9,10.9,25.6,13.4,23.8,14.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 77.4199,
    y1: 85.6499,
    x2: -13.8001,
    y2: 145.2899,
    gradientTransform: "matrix(1 0 0 1 -5.2 -113.65)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#71CDDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#4AC7E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    style: {
      stopColor: "#49C1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#4298CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#3B77B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#375BA3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#334998"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#2F3E90"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2E3B8E"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.9,14.2c0.7,0.7,1.4,1.5,2.1,2.2c0.2,0.2,0.5,0.3,0.8,0.3h7.2c0.1,0,0.2-0.1,0.2-0.2c0,0,0,0,0,0 c0-0.1,0-0.1-0.1-0.2c-2.2-0.9-4-3.3-5.7-5.1C11.5,9.3,9,7.8,6.2,7H6.1C5.8,7,5.4,6.9,5.1,6.9H4.9c-1.8,0-3.4,0.9-4.3,2.4 c-0.1,0.1,0,0.3,0.1,0.4c0,0,0,0,0,0c0,0,0.1,0,0.1,0C2.1,9.9,5.3,10.6,8.9,14.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.0425,
    y1: 84.6638,
    x2: -14.6875,
    y2: 143.3338,
    gradientTransform: "matrix(1 0 0 1 -5.2 -113.65)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#71CDDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    style: {
      stopColor: "#4AC7E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    style: {
      stopColor: "#49C1E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#4298CA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#3B77B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    style: {
      stopColor: "#375BA3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "#334998"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#2F3E90"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2E3B8E"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7.4,16.8H4.9c-2.7,0-4.9-2.2-4.9-4.9v-0.1c0-0.1,0.1-0.3,0.2-0.3c0,0,0,0,0,0h0.1c2.8,0.9,5.3,2.4,7.3,4.5 C7.6,16,8.4,16.8,7.4,16.8z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 30.29 16.9)",
    className: "st3 st4 st5"
  }, "Waterwell")), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M115.8,9.5c-1.8,0-3.2-1.4-3.2-3.2c0-1.8,1.4-3.2,3.2-3.2c1.8,0,3.2,1.4,3.2,3.2c0,0,0,0,0,0l0,0 C119,8,117.6,9.5,115.8,9.5z M115.8,3.8c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5c0,0,0,0,0,0l0,0 C118.3,4.9,117.2,3.8,115.8,3.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M115.3,6.6v1.3h-0.6V4.7h1.2c0.3,0,0.6,0.1,0.9,0.3c0.2,0.2,0.3,0.4,0.3,0.7c0,0.2,0,0.3-0.1,0.4 c-0.1,0.1-0.2,0.2-0.4,0.3c0.2,0,0.3,0.1,0.4,0.3c0.1,0.1,0.1,0.3,0.1,0.5v0.2c0,0.1,0,0.2,0,0.3c0,0.1,0.1,0.2,0.1,0.2v0.1h-0.7 c-0.1-0.1-0.1-0.2-0.1-0.2c0-0.1,0-0.2,0-0.3V7.1c0-0.1,0-0.3-0.1-0.4c-0.1-0.1-0.2-0.1-0.4-0.1H115.3z M115.3,6.1h0.6 c0.1,0,0.3,0,0.4-0.1c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.3-0.1-0.3c-0.1-0.1-0.2-0.1-0.4-0.1h-0.6L115.3,6.1z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterLogo);
export default __webpack_public_path__ + "static/media/water-logo.c5f41fb9d6f7ac0061f985779ffc518b.svg";
export { ForwardRef as ReactComponent };